/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(0, _module.loading)();
	
	//ページ内リンクのアニメーション
	//ローディング
	
	(0, _module.anchorScroll)();
	
	//ページTOP
	
	(0, _module.pageTop)();
	
	window.addEventListener('load', function () {
	  $("#question-Content").velocity({ opacity: 1 }, 400, "swing");
	});
	
	Vue.component('question-item', {
	  props: ['question', 'value'],
	  template: '<button @click="push"><p>{{ question.text }}</p></button>',
	  methods: {
	    push: function push() {
	      var value = this.value;
	      this.$emit('push-answer', value);
	    }
	  }
	});
	var vm = new Vue({
	  el: '#question-Content',
	  data: {
	    index: 0,
	    questions: ['今日の気分は？', '今日行きたい場所は？', '今日食べたいものは？'],
	    numbers: ['/campaign/garupasetlist/assets/images/common/question/ttl_question_1.png', '/campaign/garupasetlist/assets/images/common/question/ttl_question_2.png', '/campaign/garupasetlist/assets/images/common/question/ttl_question_3.png'],
	    choices: [[{ id: 1, text: 'みんなでワイワイ遊ぶ' }, { id: 2, text: '少人数でダラダラする' }, { id: 3, text: 'ひとりでゆったりする' }], [{ id: 1, text: 'ライブハウス' }, { id: 2, text: 'ショッピングモール' }, { id: 3, text: 'カフェテリア' }], [{ id: 1, text: '山吹ベーカリーのチョココロネ' }, { id: 2, text: '北沢精肉店のコロッケ' }, { id: 3, text: '花咲屋のミッシェル最中' }]],
	    answer: '',
	    answers: []
	  },
	  methods: {
	    next: function next(value) {
	      this.index++;
	      this.answers.push(value);
	      var s = this.answers;
	      var ss = s.toString();
	      var result;
	
	      if (s.length === 3) {
	        switch (ss) {
	
	          // 1問目
	          case '1,1,1':
	            //- alert('Poppin’Party（香澄）');
	            var result = "./j9y6cufp.html";
	            break;
	          case '1,1,2':
	            //- alert('ハロー、ハッピーワールド！（はぐみ）');
	            var result = "./d9viryec.html";
	            break;
	          case '1,1,3':
	            //- alert('ハロー、ハッピーワールド！（こころ）');
	            var result = "./k8qiscwx.html";
	            break;
	          case '1,2,1':
	            //- alert('Pastel＊Palettes（彩）');
	            var result = "./x4vz58ji.html";
	            break;
	          case '1,2,2':
	            //- alert('Poppin’Party（沙綾）');
	            var result = "./u9wh3qxs.html";
	            break;
	          case '1,2,3':
	            //- alert('ハロー、ハッピーワールド！（薫）');
	            var result = "./i94ryamn.html";
	            break;
	          case '1,3,1':
	            //- alert('Poppin’Party（りみ）');
	            var result = "./e8ktqpcu.html";
	            break;
	          case '1,3,2':
	            //- alert('Pastel＊Palettes（日菜）');
	            var result = "./s2bjw4k6.html";
	            break;
	          case '1,3,3':
	            //- alert('ハロー、ハッピーワールド！（美咲）');
	            var result = "./b2rgi9vf.html";
	            break;
	
	          // 2問目
	          case '2,1,1':
	            //- alert('Poppin’Party（たえ）');
	            var result = "./w7knxjdi.html";
	            break;
	          case '2,1,2':
	            //- alert('Afterglow（巴）');
	            var result = "./e8bg7jdy.html";
	            break;
	          case '2,1,3':
	            //- alert('Afterglow（蘭）');
	            var result = "./z7rpm5kf.html";
	            break;
	          case '2,2,1':
	            //- alert('Pastel＊Palettes（麻弥）');
	            var result = "./c56qsxwv.html";
	            break;
	          case '2,2,2':
	            //- alert('Afterglow（つぐみ）');
	            var result = "./x68wtqi2.html";
	            break;
	          case '2,2,3':
	            //- alert('ハロー、ハッピーワールド！（花音）');
	            var result = "./s36uth7r.html";
	            break;
	          case '2,3,1':
	            //- alert('Poppin’Party（りみ）');
	            var result = "./e8ktqpcu.html";
	            break;
	          case '2,3,2':
	            //- alert('Pastel＊Palettes（イヴ）');
	            var result = "./p2yjwbdf.html";
	            break;
	          case '2,3,3':
	            //- alert('Pastel＊Palettes（千聖）');
	            var result = "./a8svwxgm.html";
	            break;
	
	          // 3問目
	          case '3,1,1':
	            //- alert('Roselia（友希那）');
	            var result = "./c8ij23k6.html";
	            break;
	          case '3,1,2':
	            //- alert('Afterglow（ひまり）');
	            var result = "./u9qybpt3.html";
	            break;
	          case '3,1,3':
	            //- alert('Roselia（紗夜）');
	            var result = "./t459nkiv.html";
	            break;
	          case '3,2,1':
	            //- alert('Afterglow（モカ）');
	            var result = "./c5t8wpvu.html";
	            break;
	          case '3,2,2':
	            //- alert('Roselia（あこ）');
	            var result = "./s86hzk5c.html";
	            break;
	          case '3,2,3':
	            //- alert('Roselia（燐子）');
	            var result = "./b86zr4qv.html";
	            break;
	          case '3,3,1':
	            //- alert('Roselia（友希那）');
	            var result = "./c8ij23k6.html";
	            break;
	          case '3,3,2':
	            //- alert('Roselia（リサ）');
	            var result = "./m2farpw7.html";
	            break;
	          case '3,3,3':
	            //- alert('Poppin’Party（有咲）');
	            var result = "./r8ajdqy7.html";
	            break;
	        }
	        //- $.ajax({
	        //-   type: 'GET',
	        //-   url: result,
	        //-   dataType: 'html',
	        //-   success: function(data) {
	        //-     $('#result').append(data).fadeIn(1000);
	        //-   },
	        //-   error:function() {
	        //-     alert('問題がありました。');
	        //-   }
	        //- });
	        location.href = result + '?result=0';
	      }
	    }
	  },
	  computed: {
	    i: function i() {
	      return this.index;
	    }
	  }
	});
	
	$('.choice').click(function () {
	  $("#question-Content").css({ opacity: 0, visibility: "hidden" });
	  $("#question-Content").velocity({ opacity: 1 }, { visibility: "visible" }, 400, "swing");
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	var breakPoint = 767;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	//ローディング
	var loading = function loading() {
	  var $target = $('#sw-Loading');
	  window.addEventListener('load', function () {
	    setTimeout(function () {
	      $target.fadeOut(600);
	    }, 1000);
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	//ページTOP
	var pageTop = function pageTop() {
	  var topBtn = $('.sw-Top');
	  topBtn.hide();
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 100) {
	      topBtn.fadeIn();
	    } else {
	      topBtn.fadeOut();
	    }
	  });
	  topBtn.click(function () {
	    $('body,html').animate({
	      scrollTop: 0
	    }, 1000);
	    return false;
	  });
	};
	
	//export
	exports.loading = loading;
	exports.anchorScroll = anchorScroll;
	exports.pageTop = pageTop;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// question/app.bundle.js